import React from "react";
import "./visit_office_map.css";

const OfficeCard = () => {
  return (
    <section className="office-section">
      <div className="office-card">
        {/* Title */}
        <h2 className="office-title">Visit Our Office</h2>

        {/* Company Info */}
        <div className="office-info">
          <span className="office-icon">🏢</span>
          <div>
            <h3 className="company-name">My Recruitment Firm</h3>
            <p className="company-address">
              Haware Fantasia Business Park, Unit No. G-127, Ground Floor, Sector 30A, Vashi, Next to Inorbit Mall Navi Mumbai, Maharashtra 400705
            </p>
          </div>
        </div>

        {/* Map */}
        <div className="office-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.1160986425!2d72.74109995331677!3d19.082197839905295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b8f8a3f0df07%3A0x8b6d0e9ab4e8f69a!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1690000000000!5m2!1sen!2sin"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Office Location"
          ></iframe>
        </div>

        {/* Button */}
        <div className="office-btn-container">
          <a
            href="https://maps.app.goo.gl/6Q2P7p4mTQEL467a7"
            target="_blank"
            rel="noopener noreferrer"
            className="office-btn"
          >
            View on Google Maps
          </a>
        </div>
      </div>
    </section>
  );
};

export default OfficeCard;
